import PropTypes from 'prop-types';
import React from 'react';

export default class GDLink extends React.Component<any> {

    static displayName = 'Link';

    static propTypes = {
        children: PropTypes.any,
        href: PropTypes.string,
        className: PropTypes.string,
        onClick: PropTypes.func,
        newWindow: PropTypes.bool
    };

    go = (e:React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.href) gd.goTo(this.props.href);
        if (this.props.onClick) this.props.onClick();
    };

    render() {

        if (this.props.newWindow) {
            return <a href={this.props.href} className={this.props.className} target="_blank">{this.props.children}</a>;
        } else {
            return <a href={this.props.href} onClick={this.go} className={this.props.className} >{this.props.children}</a>;
        }
    }
}
